import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { AppointmentTypeResponse } from '@utils/interfaces';
import { useState, useEffect } from 'react';
import { useOBQuery } from '@hooks/useOBQuery';

interface AppointmentsRequest {
  practiceIdValue: string;
}

const useGetAppointments = ({ practiceIdValue }: AppointmentsRequest) => {
  const [practiceId, setPracticeId] = useState(practiceIdValue);
  const url = useApiUrl(
    OBRoutes.AppointmentTypes,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  useEffect(() => {
    if (practiceIdValue) setPracticeId(practiceIdValue);
  }, [practiceIdValue]);

  return useOBQuery<AppointmentTypeResponse>(url, {
    enabled: !!(url && practiceId),
    queryKey: [practiceId],
  });
};

export default useGetAppointments;
